import firebase from 'firebase/app'
import 'firebase/firebase-messaging'

import config from 'SrcConfig'

let firebaseMessaging = null
if (config.firebase && firebase.messaging.isSupported()) {
    firebase.initializeApp(config.firebase.config)
    firebaseMessaging = firebase.messaging()
}

export default firebaseMessaging